// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox";
import constants from "@store/constants";
import {
    getViewNotesNotifications,
    toggleViewNotesNotifications,
} from "@store/Framework/Services/FeaturesNotificationService";
import React from "react";
import { useEffect, useState } from "react";

interface OwnProps extends WidgetProps {}

interface FeatureNotesListCheckboxStyles {
    viewNotificationsCheckbox?: CheckboxProps;
}

const newFeaturesNotificationStyles: FeatureNotesListCheckboxStyles = {};

type Props = OwnProps;

const styles = newFeaturesNotificationStyles;

const FeatureNotesListCheckbox = () => {
    const [viewNotifications, setViewNotifications] = useState<boolean>(true);

    useEffect(() => {
        const viewNotificationsStorage = Boolean(getViewNotesNotifications());

        if (!viewNotificationsStorage) {
            setViewNotifications(false);
            return;
        }

        setViewNotifications(viewNotificationsStorage);
    }, [viewNotifications]);

    const viewNewFeaturesNotificationHandler = () => {
        toggleViewNotesNotifications();
        setViewNotifications(!viewNotifications);
    };

    return (
        <Checkbox
            {...styles.viewNotificationsCheckbox}
            onChange={viewNewFeaturesNotificationHandler}
            checked={viewNotifications}
            uid="viewNewFeaturesNotification"
        >
            {translate("View the New Features Notification on Homepage")}
        </Checkbox>
    );
};

const widgetModule: WidgetModule = {
    component: FeatureNotesListCheckbox,
    definition: {
        displayName: "Feature Notes List Checkbox",
        group: constants.widgetGroup.featureNotesList,
        allowedContexts: [constants.pageType.featureNotesList],
    },
};

export default widgetModule;
